import { useEffect, useState } from 'react';
import unsplash from '../api/unsplash';
import GlobalSnackbar from './Snackbar';
import LinearProgress from '@mui/material/LinearProgress';

import { Grid, Box } from '@mui/material';

import {
    DataGridPro,
    itIT,
    GridToolbarContainer,
    GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';
import { CustomFooterPersonalized } from '../utils/CustomFooterPersonalized';

const CDC = (props) => {
    const { idAzienda } = props;
    const [memoVisibili, setMemoVisibili] = useState([]);
    const [loading, setLoading] = useState(true);

    const [openSnack, setOpenSnack] = useState(false);
    const snack = {
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    };
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };

    const columns = [
        /*{
      filterable: false,
      field: "Actions",
      headerName: "Azioni",
      hide: false,
      width: "130",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          <IconButton
            aria-label="edit"
            onClick={async () => {
              await setMemo(params.row);
              document.getElementById("edit").click();
              handleClickOpen();
            }}
          >
            <EditIcon
              style={{ height: "2rem", width: "2rem", color: "#2265B1" }}
            />
          </IconButton>
          <DeleteDialog memo={params.row} myFunction={handleDelete} />
        </>
      ),
    },*/

        {
            field: 'Codice',
            headerName: 'Codice',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'Descrizione',
            headerName: 'Descrizione',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
        },
    ];

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                </Grid>
            </GridToolbarContainer>
        );
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                let res = await unsplash.get('cdc', {
                    params: { cliente: idAzienda },
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                });
                setMemoVisibili(res.data.data);
                setLoading(false);
            } catch (error) {
                console.error(error.message);
            }
        };
        fetchData();
    }, [idAzienda]);
    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />
            <Grid item xs={12}>
                <Grid
                    container
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="flex-end"
                >
                    {/*   <NewMemo
            id="edit"
            memoUtente={vistaMemoUtente}
            idAzienda={props.idAzienda}
            memoDati={memo}
            saveFunction={handleSave}
            title="Modifica Centro di costo"
            snack={snack}
            openSnack={openSnack}
            handleCloseSnack={handleCloseSnack}
            setSnack={setSnack}
            setOpenSnack={setOpenSnack}
          />
          <NewMemo
            id="new"
            memoUtente={vistaMemoUtente}
            idAzienda={props.idAzienda}
            saveFunction={handleSave}
            title="Nuovo Centro di costo"
            snack={snack}
            openSnack={openSnack}
            handleCloseSnack={handleCloseSnack}
            setSnack={setSnack}
            setOpenSnack={setOpenSnack}
          /> */}
                </Grid>
                <Box
                    sx={{
                        height: '60vh',
                        width: 1,
                    }}
                >
                    <DataGridPro
                        initialState={{ pinnedColumns: { left: ['Actions'] } }}
                        components={{
                            Toolbar: CustomToolbar,
                            Footer: CustomFooterPersonalized,
                        }}
                        slots={{
                            loadingOverlay: LinearProgress,
                        }}
                        loading={loading}
                        localeText={
                            itIT.components.MuiDataGrid.defaultProps.localeText
                        }
                        rowHeight={52}
                        rows={memoVisibili}
                        columns={columns}
                        getRowId={(row) => row.Codice}
                        pageSize={20}
                        rowsPerPageOptions={[20]}
                    />
                </Box>
            </Grid>
        </>
    );
};

export default CDC;
